export var countries = {
  Afghanistan: {
    name: 'Afghanistan',
    factor: 1
  },
  'Åland Islands': {
    name: 'Åland Islands',
    factor: 1
  },
  Albania: {
    name: 'Albania',
    factor: 1
  },
  Algeria: {
    name: 'Algeria',
    factor: 1
  },
  'American Samoa': {
    name: 'American Samoa',
    factor: 1
  },
  AndorrA: {
    name: 'AndorrA',
    factor: 1
  },
  Angola: {
    name: 'Angola',
    factor: 1
  },
  Anguilla: {
    name: 'Anguilla',
    factor: 1
  },
  Antarctica: {
    name: 'Antarctica',
    factor: 1
  },
  'Antigua and Barbuda': {
    name: 'Antigua and Barbuda',
    factor: 1
  },
  Argentina: {
    name: 'Argentina',
    factor: 1
  },
  Armenia: {
    name: 'Armenia',
    factor: 1
  },
  Aruba: {
    name: 'Aruba',
    factor: 1
  },
  Australia: {
    name: 'Australia',
    factor: 3
  },
  Austria: {
    name: 'Austria',
    factor: 3
  },
  Azerbaijan: {
    name: 'Azerbaijan',
    factor: 1
  },
  Bahamas: {
    name: 'Bahamas',
    factor: 1
  },
  Bahrain: {
    name: 'Bahrain',
    factor: 1
  },
  Bangladesh: {
    name: 'Bangladesh',
    factor: 1
  },
  Barbados: {
    name: 'Barbados',
    factor: 1
  },
  Belarus: {
    name: 'Belarus',
    factor: 1
  },
  Belgium: {
    name: 'Belgium',
    factor: 3
  },
  Belize: {
    name: 'Belize',
    factor: 1
  },
  Benin: {
    name: 'Benin',
    factor: 1
  },
  Bermuda: {
    name: 'Bermuda',
    factor: 1
  },
  Bhutan: {
    name: 'Bhutan',
    factor: 1
  },
  Bolivia: {
    name: 'Bolivia',
    factor: 1
  },
  'Bosnia and Herzegovina': {
    name: 'Bosnia and Herzegovina',
    factor: 1
  },
  Botswana: {
    name: 'Botswana',
    factor: 1
  },
  'Bouvet Island': {
    name: 'Bouvet Island',
    factor: 1
  },
  Brazil: {
    name: 'Brazil',
    factor: 2
  },
  'British Indian Ocean Territory': {
    name: 'British Indian Ocean Territory',
    factor: 1
  },
  'Brunei Darussalam': {
    name: 'Brunei Darussalam',
    factor: 1
  },
  Bulgaria: {
    name: 'Bulgaria',
    factor: 1
  },
  'Burkina Faso': {
    name: 'Burkina Faso',
    factor: 1
  },
  Burundi: {
    name: 'Burundi',
    factor: 1
  },
  Cambodia: {
    name: 'Cambodia',
    factor: 1
  },
  Cameroon: {
    name: 'Cameroon',
    factor: 1
  },
  Canada: {
    name: 'Canada',
    factor: 3
  },
  'Cape Verde': {
    name: 'Cape Verde',
    factor: 1
  },
  'Cayman Islands': {
    name: 'Cayman Islands',
    factor: 1
  },
  'Central African Republic': {
    name: 'Central African Republic',
    factor: 1
  },
  Chad: {
    name: 'Chad',
    factor: 1
  },
  'Channel Islands': {
    name: 'Channel Islands',
    factor: 3
  },
  Chile: {
    name: 'Chile',
    factor: 2
  },
  China: {
    name: 'China',
    factor: 2
  },
  'Christmas Island': {
    name: 'Christmas Island',
    factor: 1
  },
  'Cocos (Keeling) Islands': {
    name: 'Cocos (Keeling) Islands',
    factor: 1
  },
  Colombia: {
    name: 'Colombia',
    factor: 2
  },
  Comoros: {
    name: 'Comoros',
    factor: 1
  },
  Congo: {
    name: 'Congo',
    factor: 1
  },
  'Congo, The Democratic Republic of the': {
    name: 'Congo, The Democratic Republic of the',
    factor: 1
  },
  'Cook Islands': {
    name: 'Cook Islands',
    factor: 1
  },
  'Costa Rica': {
    name: 'Costa Rica',
    factor: 1
  },
  'Cote DIvoire': {
    name: 'Cote DIvoire',
    factor: 1
  },
  Croatia: {
    name: 'Croatia',
    factor: 1
  },
  Cuba: {
    name: 'Cuba',
    factor: 1
  },
  Cyprus: {
    name: 'Cyprus',
    factor: 1
  },
  'Czech Republic': {
    name: 'Czech Republic',
    factor: 1
  },
  Denmark: {
    name: 'Denmark',
    factor: 3
  },
  Djibouti: {
    name: 'Djibouti',
    factor: 1
  },
  Dominica: {
    name: 'Dominica',
    factor: 1
  },
  'Dominican Republic': {
    name: 'Dominican Republic',
    factor: 1
  },
  Ecuador: {
    name: 'Ecuador',
    factor: 1
  },
  Egypt: {
    name: 'Egypt',
    factor: 1
  },
  'El Salvador': {
    name: 'El Salvador',
    factor: 1
  },
  'Equatorial Guinea': {
    name: 'Equatorial Guinea',
    factor: 1
  },
  Eritrea: {
    name: 'Eritrea',
    factor: 1
  },
  Estonia: {
    name: 'Estonia',
    factor: 1
  },
  Ethiopia: {
    name: 'Ethiopia',
    factor: 1
  },
  'Falkland Islands (Malvinas)': {
    name: 'Falkland Islands (Malvinas)',
    factor: 1
  },
  'Faroe Islands': {
    name: 'Faroe Islands',
    factor: 1
  },
  Fiji: {
    name: 'Fiji',
    factor: 1
  },
  Finland: {
    name: 'Finland',
    factor: 3
  },
  France: {
    name: 'France',
    factor: 3
  },
  'French Guiana': {
    name: 'French Guiana',
    factor: 1
  },
  'French Polynesia': {
    name: 'French Polynesia',
    factor: 1
  },
  'French Southern Territories': {
    name: 'French Southern Territories',
    factor: 1
  },
  Gabon: {
    name: 'Gabon',
    factor: 1
  },
  Gambia: {
    name: 'Gambia',
    factor: 1
  },
  Georgia: {
    name: 'Georgia',
    factor: 1
  },
  Germany: {
    name: 'Germany',
    factor: 3
  },
  Ghana: {
    name: 'Ghana',
    factor: 1
  },
  Gibraltar: {
    name: 'Gibraltar',
    factor: 1
  },
  Greece: {
    name: 'Greece',
    factor: 1
  },
  Greenland: {
    name: 'Greenland',
    factor: 1
  },
  Grenada: {
    name: 'Grenada',
    factor: 1
  },
  Guadeloupe: {
    name: 'Guadeloupe',
    factor: 1
  },
  Guam: {
    name: 'Guam',
    factor: 1
  },
  Guatemala: {
    name: 'Guatemala',
    factor: 1
  },
  Guernsey: {
    name: 'Guernsey',
    factor: 1
  },
  Guinea: {
    name: 'Guinea',
    factor: 1
  },
  'Guinea-Bissau': {
    name: 'Guinea-Bissau',
    factor: 1
  },
  Guyana: {
    name: 'Guyana',
    factor: 1
  },
  Haiti: {
    name: 'Haiti',
    factor: 1
  },
  'Heard Island and Mcdonald Islands': {
    name: 'Heard Island and Mcdonald Islands',
    factor: 1
  },
  'Holy See (Vatican City State)': {
    name: 'Holy See (Vatican City State)',
    factor: 1
  },
  Honduras: {
    name: 'Honduras',
    factor: 1
  },
  'Hong Kong': {
    name: 'Hong Kong',
    factor: 3
  },
  Hungary: {
    name: 'Hungary',
    factor: 1
  },
  Iceland: {
    name: 'Iceland',
    factor: 3
  },
  India: {
    name: 'India',
    factor: 1
  },
  Indonesia: {
    name: 'Indonesia',
    factor: 1
  },
  Iran: {
    name: 'Iran, Islamic Republic Of',
    factor: 1
  },
  Iraq: {
    name: 'Iraq',
    factor: 1
  },
  Ireland: {
    name: 'Ireland',
    factor: 3
  },
  'Isle of Man': {
    name: 'Isle of Man',
    factor: 1
  },
  Israel: {
    name: 'Israel',
    factor: 1
  },
  Italy: {
    name: 'Italy',
    factor: 3
  },
  Jamaica: {
    name: 'Jamaica',
    factor: 1
  },
  Japan: {
    name: 'Japan',
    factor: 3
  },
  Jersey: {
    name: 'Jersey',
    factor: 1
  },
  Jordan: {
    name: 'Jordan',
    factor: 1
  },
  Kazakhstan: {
    name: 'Kazakhstan',
    factor: 1
  },
  Kenya: {
    name: 'Kenya',
    factor: 1
  },
  Kiribati: {
    name: 'Kiribati',
    factor: 1
  },
  'Korea, Democratic PeopleS Republic of': {
    name: 'Korea, Democratic PeopleS Republic of',
    factor: 1
  },
  'Korea, Republic of': {
    name: 'Korea, Republic of',
    factor: 3
  },
  Kuwait: {
    name: 'Kuwait',
    factor: 1
  },
  Kyrgyzstan: {
    name: 'Kyrgyzstan',
    factor: 1
  },
  'Lao PeopleS Democratic Republic': {
    name: 'Lao PeopleS Democratic Republic',
    factor: 1
  },
  Latvia: {
    name: 'Latvia',
    factor: 1
  },
  Lebanon: {
    name: 'Lebanon',
    factor: 1
  },
  Lesotho: {
    name: 'Lesotho',
    factor: 1
  },
  Liberia: {
    name: 'Liberia',
    factor: 1
  },
  'Libyan Arab Jamahiriya': {
    name: 'Libyan Arab Jamahiriya',
    factor: 1
  },
  Liechtenstein: {
    name: 'Liechtenstein',
    factor: 1
  },
  Lithuania: {
    name: 'Lithuania',
    factor: 1
  },
  Luxembourg: {
    name: 'Luxembourg',
    factor: 3
  },
  Macao: {
    name: 'Macao',
    factor: 1
  },
  Macedonia: {
    name: 'Macedonia, The Former Yugoslav Republic of',
    factor: 1
  },
  Madagascar: {
    name: 'Madagascar',
    factor: 1
  },
  Malawi: {
    name: 'Malawi',
    factor: 1
  },
  Malaysia: {
    name: 'Malaysia',
    factor: 1
  },
  Maldives: {
    name: 'Maldives',
    factor: 1
  },
  Mali: {
    name: 'Mali',
    factor: 1
  },
  Malta: {
    name: 'Malta',
    factor: 3
  },
  'Marshall Islands': {
    name: 'Marshall Islands',
    factor: 1
  },
  Martinique: {
    name: 'Martinique',
    factor: 1
  },
  Mauritania: {
    name: 'Mauritania',
    factor: 1
  },
  Mauritius: {
    name: 'Mauritius',
    factor: 1
  },
  Mayotte: {
    name: 'Mayotte',
    factor: 1
  },
  Mexico: {
    name: 'Mexico',
    factor: 1
  },
  'Micronesia, Federated States of': {
    name: 'Micronesia, Federated States of',
    factor: 1
  },
  'Moldova, Republic of': {
    name: 'Moldova, Republic of',
    factor: 1
  },
  Monaco: {
    name: 'Monaco',
    factor: 1
  },
  Mongolia: {
    name: 'Mongolia',
    factor: 1
  },
  Montserrat: {
    name: 'Montserrat',
    factor: 1
  },
  Morocco: {
    name: 'Morocco',
    factor: 1
  },
  Mozambique: {
    name: 'Mozambique',
    factor: 1
  },
  Myanmar: {
    name: 'Myanmar',
    factor: 1
  },
  Namibia: {
    name: 'Namibia',
    factor: 1
  },
  Nauru: {
    name: 'Nauru',
    factor: 1
  },
  Nepal: {
    name: 'Nepal',
    factor: 1
  },
  Netherlands: {
    name: 'Netherlands',
    factor: 3
  },
  'Netherlands Antilles': {
    name: 'Netherlands Antilles',
    factor: 1
  },
  'New Caledonia': {
    name: 'New Caledonia',
    factor: 1
  },
  'New Zealand': {
    name: 'New Zealand',
    factor: 3
  },
  Nicaragua: {
    name: 'Nicaragua',
    factor: 1
  },
  Niger: {
    name: 'Niger',
    factor: 1
  },
  Nigeria: {
    name: 'Nigeria',
    factor: 1
  },
  Niue: {
    name: 'Niue',
    factor: 1
  },
  'Norfolk Island': {
    name: 'Norfolk Island',
    factor: 1
  },
  'Northern Mariana Islands': {
    name: 'Northern Mariana Islands',
    factor: 1
  },
  Norway: {
    name: 'Norway',
    factor: 3
  },
  Oman: {
    name: 'Oman',
    factor: 1
  },
  Pakistan: {
    name: 'Pakistan',
    factor: 1
  },
  Palau: {
    name: 'Palau',
    factor: 1
  },
  'Palestinian Territory, Occupied': {
    name: 'Palestinian Territory, Occupied',
    factor: 1
  },
  Panama: {
    name: 'Panama',
    factor: 1
  },
  'Papua New Guinea': {
    name: 'Papua New Guinea',
    factor: 1
  },
  Paraguay: {
    name: 'Paraguay',
    factor: 1
  },
  Peru: {
    name: 'Peru',
    factor: 1
  },
  Philippines: {
    name: 'Philippines',
    factor: 1
  },
  Pitcairn: {
    name: 'Pitcairn',
    factor: 1
  },
  Poland: {
    name: 'Poland',
    factor: 1
  },
  Portugal: {
    name: 'Portugal',
    factor: 3
  },
  'Puerto Rico': {
    name: 'Puerto Rico',
    factor: 1
  },
  Qatar: {
    name: 'Qatar',
    factor: 1
  },
  Reunion: {
    name: 'Reunion',
    factor: 1
  },
  Romania: {
    name: 'Romania',
    factor: 1
  },
  'Russian Federation': {
    name: 'Russian Federation',
    factor: 1
  },
  RWANDA: {
    name: 'RWANDA',
    factor: 1
  },
  'Saint Helena': {
    name: 'Saint Helena',
    factor: 1
  },
  'Saint Kitts and Nevis': {
    name: 'Saint Kitts and Nevis',
    factor: 1
  },
  'Saint Lucia': {
    name: 'Saint Lucia',
    factor: 1
  },
  'Saint Pierre and Miquelon': {
    name: 'Saint Pierre and Miquelon',
    factor: 1
  },
  'Saint Vincent and the Grenadines': {
    name: 'Saint Vincent and the Grenadines',
    factor: 1
  },
  Samoa: {
    name: 'Samoa',
    factor: 1
  },
  'San Marino': {
    name: 'San Marino',
    factor: 1
  },
  'Sao Tome and Principe': {
    name: 'Sao Tome and Principe',
    factor: 1
  },
  'Saudi Arabia': {
    name: 'Saudi Arabia',
    factor: 1
  },
  Senegal: {
    name: 'Senegal',
    factor: 1
  },
  'Serbia and Montenegro': {
    name: 'Serbia and Montenegro',
    factor: 1
  },
  Seychelles: {
    name: 'Seychelles',
    factor: 1
  },
  'Sierra Leone': {
    name: 'Sierra Leone',
    factor: 1
  },
  Singapore: {
    name: 'Singapore',
    factor: 1
  },
  Slovakia: {
    name: 'Slovakia',
    factor: 1
  },
  Slovenia: {
    name: 'Slovenia',
    factor: 1
  },
  'Solomon Islands': {
    name: 'Solomon Islands',
    factor: 1
  },
  Somalia: {
    name: 'Somalia',
    factor: 1
  },
  'South Africa': {
    name: 'South Africa',
    factor: 1
  },
  'South Georgia and the South Sandwich Islands': {
    name: 'South Georgia and the South Sandwich Islands',
    factor: 1
  },
  Spain: {
    name: 'Spain',
    factor: 3
  },
  'Sri Lanka': {
    name: 'Sri Lanka',
    factor: 1
  },
  Sudan: {
    name: 'Sudan',
    factor: 1
  },
  Suriname: {
    name: 'Suriname',
    factor: 1
  },
  'Svalbard and Jan Mayen': {
    name: 'Svalbard and Jan Mayen',
    factor: 1
  },
  Swaziland: {
    name: 'Swaziland',
    factor: 1
  },
  Sweden: {
    name: 'Sweden',
    factor: 3
  },
  Switzerland: {
    name: 'Switzerland',
    factor: 3
  },
  'Syrian Arab Republic': {
    name: 'Syrian Arab Republic',
    factor: 1
  },
  'Taiwan, Province of China': {
    name: 'Taiwan, Province of China',
    factor: 1
  },
  Tajikistan: {
    name: 'Tajikistan',
    factor: 1
  },
  'Tanzania, United Republic of': {
    name: 'Tanzania, United Republic of',
    factor: 1
  },
  Thailand: {
    name: 'Thailand',
    factor: 1
  },
  'Timor-Leste': {
    name: 'Timor-Leste',
    factor: 1
  },
  Togo: {
    name: 'Togo',
    factor: 1
  },
  Tokelau: {
    name: 'Tokelau',
    factor: 1
  },
  Tonga: {
    name: 'Tonga',
    factor: 1
  },
  '': {
    name: 'Trinidad and Tobago',
    factor: 1
  },
  Tunisia: {
    name: 'Tunisia',
    factor: 1
  },
  Turkey: {
    name: 'Turkey',
    factor: 1
  },
  Turkmenistan: {
    name: 'Turkmenistan',
    factor: 1
  },
  'Turks and Caicos Islands': {
    name: 'Turks and Caicos Islands',
    factor: 1
  },
  Tuvalu: {
    name: 'Tuvalu',
    factor: 1
  },
  Uganda: {
    name: 'Uganda',
    factor: 1
  },
  Ukraine: {
    name: 'Ukraine',
    factor: 1
  },
  'United Arab Emirates': {
    name: 'United Arab Emirates',
    factor: 3
  },
  'United Kingdom': {
    name: 'United Kingdom',
    factor: 3
  },
  'United States': {
    name: 'United States',
    factor: 3
  },
  'United States Minor Outlying Islands': {
    name: 'United States Minor Outlying Islands',
    factor: 1
  },
  Uruguay: {
    name: 'Uruguay',
    factor: 1
  },
  Uzbekistan: {
    name: 'Uzbekistan',
    factor: 1
  },
  Vanuatu: {
    name: 'Vanuatu',
    factor: 1
  },
  Venezuela: {
    name: 'Venezuela',
    factor: 1
  },
  'Viet Nam': {
    name: 'Viet Nam',
    factor: 1
  },
  'Virgin Islands, British': {
    name: 'Virgin Islands, British',
    factor: 1
  },
  'Virgin Islands, U.S.': {
    name: 'Virgin Islands, U.S.',
    factor: 1
  },
  'Wallis and Futuna': {
    name: 'Wallis and Futuna',
    factor: 1
  },
  'Western Sahara': {
    name: 'Western Sahara',
    factor: 1
  },
  Yemen: {
    name: 'Yemen',
    factor: 1
  },
  Zambia: {
    name: 'Zambia',
    factor: 1
  },
  Zimbabwe: {
    name: 'Zimbabwe',
    factor: 1
  }
};